module.exports = __webpack_public_path__ + "static/media/premium_plan_icon.91f824ad.svg";